import React from "react";
import BeeHive from "./assets/BeeHive.png";
import Beekeeping from "./assets/Beekeeping.png";
import TSTransco from "./assets/TSTransco.png";
import QueenBee from "./assets/QueenBee.png";
import Brood from "./assets/Brood.png";

const AboutUs = () => {
  return (
    <div className="font-poppins mt-27 text-[#333]  bg-fixed flex flex-col items-center min-h-screen overflow-y-auto">
      {/* First Section */}
      <div className="w-full flex justify-center items-center mt-5">
        <div className="w-[80%] max-w-[2000px] bg-[rgba(254,232,217,0.5)] rounded-lg p-5 shadow-md transition-transform transition-shadow duration-300 ease-in-out ml-[50px] mr-[50px] hover:shadow-lg hover:scale-[1.02]">
          <div className="about-us-content">
            <h1 className="text-center text-4xl font-bold [-webkit-text-stroke:1px_#5a3e12] text-shadow-[3px_3px_6px_rgba(255,255,255,0.5)]">
              <b>THE GREAT HONEY CO. (TGHC)</b>
            </h1>

            <div className="flex justify-between items-center bg-gradient-to-r from-[#edd2d1] to-[#c0a67b] p-3 rounded-lg shadow-md mt-5 transition-transform duration-300 ease-in-out hover:translate-y-[-5px]">
              <div className="w-[60%]">
                <h2 className="text-2xl font-bold">OUR VISION</h2>
                <p className="text-base">
                  To revolutionize sustainable honey production while empowering farmers and fostering a thriving ecosystem through beekeeping. Our goal is to create a thriving, self-sustaining network of responsible beekeepers. Through innovation, we strive to ensure the highest quality honey production. Ultimately, we seek to make beekeeping a driving force for environmental and economic growth.
                </p>
              </div>
              <div className="w-[200px] h-[250px] object-cover rounded-lg transition-transform duration-300 ease-in-out">
                <img src={BeeHive} alt="Beehive" className="w-full h-full object-cover rounded-lg hover:scale-[1.05]" />
              </div>
            </div>

            <div className="flex justify-between items-center bg-gradient-to-l from-[#edd2d1] to-[#c0a67b] p-3 rounded-lg shadow-md mt-5 transition-transform duration-300 ease-in-out hover:translate-y-[-5px]">
              <div className="w-[200px] h-[250px] object-cover rounded-lg transition-transform duration-300 ease-in-out">
                <img src={Beekeeping} alt="Beekeeping" className="w-full h-full object-cover rounded-lg hover:scale-[1.05]" />
              </div>
              <div className="w-[60%]">
                <h2 className="text-2xl font-bold">OUR MISSION</h2>
                <p className="text-base">
                  At TGHC, our mission is to enhance agricultural productivity by promoting beekeeping, ensuring high-quality honey production, and supporting farmers with innovative techniques and sustainable practices. Our mission is to educate and support farmers in adopting beekeeping for agricultural improvement. We are committed to producing pure, high-quality honey using ethical and eco-friendly practices. By fostering awareness of the importance of bees, we aim to strengthen global sustainability efforts.
                </p>
              </div>
            </div>

            <div className="mt-5">
              <h2 className="text-2xl font-bold">HOW WE STARTED?</h2>
              <p className="text-base">
                It would be just another ordinary day in SIBM Pune if I hadn’t met my friend, who made me understand the situation of farmers who toil a lot but still, the yield depends on several factors. We met several farmers and heard about their problems. We were astonished to hear about the factors affecting the yield and the methods farmers follow in agriculture.
              </p>
              <p className="text-base">
                We analyzed the reasons for the shortage of resources and also researched ways to improve the yield. We found out that a small bee can help many farmers improve the quality and quantity of their products. The bees help in cross-pollination by which the reproduction in plants will happen at a better rate. This research has paved the way for me to start the first step in establishing the company.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Our Team Section */}
      <div className="p-10 text-center bg-[rgba(218,214,190,0.5)] w-full mt-10 text-[#000000]">
        <h2 className="text-3xl text-[#804b0b] mb-2.5 font-bold">
          <b>OUR TEAM OF EXPERTS</b>
        </h2>
        <p className="text-sm mb-7.5">
          Meet our passionate team of honey production professionals
        </p>
        <div className="flex gap-5 justify-center flex-wrap">
          <div>
            <img src={Brood} alt="Best Brood" className="w-[250px] h-[250px] rounded-lg object-cover shadow-md transition-transform duration-300 ease-in-out hover:scale-[1.05]" />
            <p className="text-xl pt-5 font-bold">BEST BROOD AVAILABLE</p>
          </div>
          <div>
            <img src={QueenBee} alt="Shipping Queen Bee" className="w-[250px] h-[250px] rounded-lg object-cover shadow-md transition-transform duration-300 ease-in-out hover:scale-[1.05]" />
            <p className="text-xl pt-5 font-bold">SHIPPING QUEEN BEE</p>
          </div>
          <div>
            <img src={TSTransco} alt="Working with TSTRANSCO" className="w-[250px] h-[250px] rounded-lg object-cover shadow-md transition-transform duration-300 ease-in-out hover:scale-[1.05]" />
            <p className="text-xl pt-5 font-bold">WORKING WITH TSTRANSCO</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;